'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./node_modules/gopd/gOPD.js
// module id = 99
// module chunks = 0